import { useMemo } from 'react';
import {
  DialogContent,
  DialogContentText,
  Typography,
  Button,
  useMediaQuery,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { useAccount } from '../../../contexts/Account';
import DefaultCompany from '../../../icons/building_round.svg';

const useStyles = ({ isSM }) => ({
  dialogContent: {
    mt: '20px',
    padding:'0px',
  },
  dialogText: {
    textAlign: 'left',
    mx: '0px',
    px: { xxs: '30px', xs: '0px' },
  },
  dialogTextCompanyName: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '100%',
    px: { xxs: '60px', xs: '0px' },
  },
  dialogCompanyImage: {
    width: '32px',
    height: '32px',
    borderRadius: '146px',
    cursor: 'pointer',
    marginRight: '8px',
  },
  card: {
    borderRadius: 2,
    bgcolor: '#fafcff',
    mb: 2,
    width: '100%',
  },
  cardHeader: {
    display: 'flex',
    mb: 2,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTitle: {
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '32px',
    color: '#232B35',
  },
  cardButton: {
    backgroundColor: '#4FB5F9',
    color: '#FFFFFF',
    textTransform: 'none',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '18px',
    padding: '8px 16px',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#4FB5F9',
    },
  },
});

export default function Main({ setActiveStep, survey, setUpdateType }) {
  const { accountDetails } = useAccount();
  const srcImage = useMemo(() => {
    if (accountDetails?.image?.id) {
      return `${process.env.REACT_APP_IMAGES_URL}${accountDetails.image.id}`;
    }
    return DefaultCompany;
  }, []);

  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles({ isSM });

  function handleNexStep(type) {
    setActiveStep((prevStep) => prevStep + 1);
    setUpdateType(type);
  }

  return (
    <DialogContent sx={classes.dialogContent}>
      <DialogContentText sx={classes.dialogTextCompanyName}>
        <img
          alt="Company Avatar"
          className="profileAvatar"
          style={classes.dialogCompanyImage}
          src={srcImage}
        />
        <Typography
          variant="caption"
          sx={{
            fontSize: '16px',
            lineHeight: '20px',
            letterSpacing: '-0.43px',
            textTransform: 'none',
            fontWeight: 600,
            color: '#232B35',
            verticalAlign: 'middle',
          }}
        >
          Current Priorities
        </Typography>
      </DialogContentText>
      <DialogContent sx={classes.dialogText}>
        <Card variant="outlined" sx={classes.card}>
          <CardContent>
            <Box sx={classes.cardHeader}>
              <Typography sx={classes.cardTitle}>Survey</Typography>
              <Button
                sx={classes.cardButton}
                onClick={() => handleNexStep('survey')}
              >
                <AddCircleOutline sx={{ mr: '6px' }} />
                New Survey
              </Button>
            </Box>
            <Typography>{survey.body}</Typography>
          </CardContent>
        </Card>
        <Card variant="outlined" sx={classes.card}>
          <CardContent>
            <Box sx={classes.cardHeader}>
              <Typography sx={classes.cardTitle}>Current Priority</Typography>
              <Button
                sx={classes.cardButton}
                onClick={() => handleNexStep('goal')}
              >
                <AddCircleOutline sx={{ mr: '6px' }} />
                Update Priority
              </Button>
            </Box>
            <Typography>{accountDetails.currentGoal}</Typography>
          </CardContent>
        </Card>
      </DialogContent>
    </DialogContent>
  );
}
